import Link from "@tiptap/extension-link";
import { Plugin, PluginKey } from "@tiptap/pm/state";

/**
 * Shared link mark for the app's rich text editors (mail & agenda):
 * - non-inclusive: text typed right after a link is not swallowed into it;
 * - links open only on Ctrl/Cmd+click, so a plain click keeps editing.
 *
 * Editors can `.extend()` this to add their own attributes/rendering/commands;
 * the behaviours above are inherited (openOnClick is forced off via options).
 */
const CustomLink = Link.extend({
    inclusive() {
        return false;
    },
    addOptions() {
        return {
            ...this.parent?.(),
            openOnClick: false,
        };
    },
    addProseMirrorPlugins() {
        return [
            ...(this.parent?.() ?? []),
            new Plugin({
                key: new PluginKey("customLinkCtrlClick"),
                props: {
                    handleClick: (_view, _pos, event) => {
                        if (
                            event.button !== 0 ||
                            !(event.ctrlKey || event.metaKey)
                        ) {
                            return false;
                        }
                        const link = (event.target as HTMLElement)?.closest(
                            "a",
                        );
                        const href = link?.getAttribute("href");
                        if (!href) {
                            return false;
                        }
                        window.open(href, "_blank", "noopener,noreferrer");

                        return true;
                    },
                },
            }),
        ];
    },
});

export default CustomLink;
